import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useCompanyData } from "../../../lib/useMockData";

export default function VisionSection() {
  const { visionData } = useCompanyData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal direction="up">
            <p className="section-label mb-3">{visionData.label}</p>
            <h2 className="section-title">{visionData.title}</h2>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={150}>
            <p className="mt-8 text-xl md:text-2xl font-serif font-semibold text-airdoa-navy leading-[1.6]">
              {visionData.lead}
            </p>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={250}>
            <div className="mt-8 flex flex-col gap-5">
              {visionData.paragraphs.map((paragraph, idx) => (
                <p
                  key={idx}
                  className="text-base text-airdoa-gray leading-[2]"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}